import { render, staticRenderFns } from "./PrivacyPolicyExternal.vue?vue&type=template&id=5b6b20a8"
import script from "./PrivacyPolicyExternal.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports